<template>
  <div class="shipment-tag-wrapper shipment-tag-jadlog-smartlabel">
    <div class="shipment-root">
      <div class="flex mb-2 b-b">
        <div class="tag-content">
          <div class="flex p-info b-b">
            <div class="flex flex-col">
              <img :src="shippingCompanyIcon" class="jadlog-logo mb-1">

              <span v-show="$parent.tag.authorizationCode && $parent.tag.protocol" class="text-protocol">
                {{ $parent.tag.protocol }}
              </span>
            </div>

            <canvas class="melhor-ponto-code"></canvas>
          </div>

          <div class="section-to px-1 pb b-b">
            <p>
             {{ $parent.tag.to.address }}<template v-if="$parent.tag.to.locationNumber.length">, </template>
             {{ $parent.tag.to.locationNumber }}
            </p>

            <p>
              {{ $parent.tag.to.complement }}<template v-if="$parent.tag.to.complement.length">, </template>
              {{ $parent.tag.to.district }}
            </p>

            <p>
              <strong>{{ beautifyPostalCode($parent.tag.to.postalCode) }}</strong>
              {{ $parent.tag.to.city }}<template v-if="$parent.tag.to.stateAbbr.length">/</template>{{ $parent.tag.to.stateAbbr }}
            </p>

            <p v-if="$parent.tag.to.note" class="spacing-small">
              <strong>obs: </strong> {{ $parent.tag.to.note }}
            </p>

            <p class="flex mt-1">
              <span class="flex-0">Recebedor:</span>
              <span class="flex-1 b-b"></span>
            </p>
          </div>

          <div class="flex">
            <div class="flex-1 flex flex-col b-r">
              <div class="flex-1 flex flex-col justify-center section-contact px-1 py b-b">
                <small>Contato:</small>

                <p>
                 {{ String($parent.tag.to.name).toUpperCase() }}
                </p>

                <p class="mt-2">
                  <small>Telefone:</small>
                  <template v-if="$parent.tag.to.phone.length">{{ maskPhone($parent.tag.to.phone) }}</template>
                </p>
              </div>

              <div class="flex-1 flex flex-col justify-center section-declaration px-1 py relative">
                <p v-if="$parent.tag.invoice.number" class="mb-1">NF: {{ $parent.tag.invoice.number }}</p>
                <p v-else class="mb-1">DECLARAÇÃO:</p>

                <small>Unidade Jadlog de destino</small>
                <p>{{ ($parent.volume && $parent.volume.unidadeDestino) || 'XXXXX XXX' }}</p>
                <p>{{ $parent.tag.authorizationCode }}</p>

                <p v-if="hasAdditionalInfo" class="shipment-id">
                  <strong>{{ String($parent.tag.additionalInfo.shipmentId).substring(0, 6) }}</strong>
                  {{ String($parent.tag.additionalInfo.shipmentId).substring(6, 10) }}
                  {{ String($parent.tag.additionalInfo.shipmentId).substring(10, 14) }}
                </p>
              </div>
            </div>

            <div class="flex-0">
              <ul class="p b-b">
                <li class="mb">
                  <p>Pacotes</p>

                  <b>{{ packages }}</b>
                </li>

                <li class="mb">
                  <p>Peso</p>

                  <b v-if="hasVolume && $parent.volume.seqVolume">
                    {{ $parent.tag.package.weight }}Kg
                  </b>

                  <b v-else>1Kg</b>
                </li>

                <li v-if="dimensions">
                  <p>Dimensões</p>

                  <b>
                    {{ dimensions }}
                  </b>
                </li>
              </ul>

              <div class="flex justify-center py relative">
                <h2>{{ hasVolume ? $parent.volume.prioridade : '1' }}</h2>

                <p class="service-name"><strong>{{ serviceName }}</strong></p>
              </div>
            </div>
          </div>
        </div>

        <div class="tag-content tag-content--aside flex flex-col b-l">
          <div class="logo b-b">
            <img :src="$parent.tag.companyIcon">
          </div>

          <div class="flex flex-1">
            <div class="flex flex-1 flex-col b-r">
              <div
                class="flex flex-col items-center justify-center py-1 b-b"
                :class="{
                  inverse: isDotCom,
                }"
              >
                <h2>{{ hasVolume ? $parent.volume.rua : 'S' }}</h2>
                <h3>{{ hasVolume ? $parent.volume.posicao : '00' }}</h3>
              </div>

              <div class="section-from flex items-center justify-center py vertical-text p">
                <div class="height-box">
                  <p>
                    {{ $parent.tag.from.name }}
                  </p>

                  <p>
                    {{ $parent.tag.from.address }}<template v-if="$parent.tag.from.locationNumber.length">, </template>
                    {{ $parent.tag.from.locationNumber }}
                  </p>

                  <p>
                    {{ $parent.tag.from.complement }}<template v-if="$parent.tag.from.complement.length">, </template>
                    {{ $parent.tag.from.district }}
                  </p>

                  <p>
                    {{ beautifyPostalCode($parent.tag.from.postalCode) }}
                    {{ $parent.tag.from.city }}<template v-if="$parent.tag.from.stateAbbr.length">/</template>{{ $parent.tag.from.stateAbbr }}
                  </p>

                  <p v-if="$parent.tag.from.phone">
                    Telefone: {{ maskPhone($parent.tag.from.phone) }}
                  </p>
                </div>
              </div>
            </div>

            <div class="flex flex-1 flex-col items-center justify-center">
              <div class="bar-code">
                <canvas
                  class="barcode img-code"
                  :data-value="hasAdditionalInfo && hasVolume ? `${$parent.tag.additionalInfo.shipmentId}$${$parent.volume.seqVolume.toString().padStart(3, '0')}` : 'MELHOR ENVIO'"
                  data-height="55"
                  data-margin="0"
                  data-font="arial"
                  data-displayvalue="false"
                  data-textposition="bottom"
                ></canvas>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="px pt-1 b-b">
        <div class="flex items-end">
          <div class="flex flex-col items-center">
            <small>Track</small>

            <div class="track">
              {{ hasVolume ? $parent.volume.prioridade : '1' }}
            </div>
          </div>

          <h4 class="mx-auto">{{ hasVolume ? `${$parent.volume.rota}-${$parent.volume.lastMile}` : 'MELHOR ENVIO' }}</h4>
        </div>

        <div class="flex flex-col items-center">
          <div class="bar-code-bottom">
            <canvas
              class="barcode"
              :data-value="hasVolume ? $parent.volume.codbarra : 'MELHOR ENVIO'"
              data-height="50"
              data-margin="0"
              data-font="arial"
              data-displayvalue="false"
              data-textposition="bottom"
            ></canvas>
          </div>

          <small>{{ barCode }}</small>
        </div>
      </div>

      <div class="flex justify-center py">
        <div class="bar-code-bottom">
          <div>
            <p class="text-xs text-center">{{ $parent.tag.authorizationCode || '00000' }}</p>

            <canvas
              class="barcode barcode-small"
              :data-value="$parent.tag.authorizationCode || '00000'"
              data-height="30"
              data-margin="0"
              data-displayvalue="false"
            ></canvas>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { kilogramsToGrams, maskPhone } from 'commons/js/formatters/Mask';
import { beautifyPostalCode } from 'commons/js/formatters/PostalCode';
import MelhorPontoQrCode from 'commons/js/mixins/melhorPontoQrCode.js';
import ShippingDefinitions from 'commons/js/ShippingDefinitions';

export default {
  name: 'jadlog-shipment-tag',

  mixins: [MelhorPontoQrCode],

  data() {
    return {
      shippingCompanyIcon: ''
    }
  },

  computed: {
    hasAdditionalInfo: function () {
      return !!(this.$parent.tag && this.$parent.tag.additionalInfo);
    },
    hasVolume: function () {
      return !!this.$parent.volume && !!this.$parent.volume.seqVolume;
    },
    serviceName: function () {
      switch (Number(this.$parent.tag.serviceId)) {
        case ShippingDefinitions.JADLOG_DOTPACKAGE_ID:
        case ShippingDefinitions.JADLOG_DOTPACKAGECENTRALIZADO_ID:
          return 'PAK';
        case ShippingDefinitions.JADLOG_DOTCOM_ID:
          return 'COM';
      }
      return 'ECO';
    },
    isDotCom: function () {
      return +this.$parent.tag.serviceId === ShippingDefinitions.JADLOG_DOTCOM_ID;
    },
    packages: function () {
      const volume = (this.$parent.tag.volumeIndex + 1).toString().padStart(3, '0');
      const total = this.$parent.tag.volumeTotal.toString().padStart(3, '0');

      return `${volume}/${total}`;
    },
    dimensions: function () {
      if (!this.$parent.tag && !this.$parent.tag.package) return null;

      return `${this.$parent.tag.package.height}x${this.$parent.tag.package.width}x${this.$parent.tag.package.length}`;
    },
    barCode() {
      const barcode = this.hasVolume ? String(this.$parent.volume.codbarra) : '';

      if (barcode) {
        return barcode
          .replace('$', '')
          .match(/.{1,4}/g) // match any character, at least 1 and at most 4
          .join(' ');
      }

      return barcode;
    },
  },

  methods: {
    kilogramsToGrams,
    maskPhone,
    beautifyPostalCode
  },

  mounted() {
    BarCode('.barcode').init();

    switch (Number(this.$parent.tag.serviceId)) {
      case ShippingDefinitions.JADLOG_DOTPACKAGE_ID:
      case ShippingDefinitions.JADLOG_DOTPACKAGECENTRALIZADO_ID:
        this.shippingCompanyIcon = '/images/shipment/jadlog/dot-package.png';
        break;
      case ShippingDefinitions.JADLOG_DOTCOM_ID:
        this.shippingCompanyIcon = '/images/shipment/jadlog/dot-com.png';
        break;
    }
  },
}
</script>

<style lang="stylus" scoped>
@import url('https://fonts.googleapis.com/css?family=Roboto:400,700');
.shipment-root
  .p
    padding 1.2px
    &-info
      padding 6px 20px 6px 8px
    &x
      padding-left 4px
      padding-right 4px
    &x-1
      padding-left 8px
      padding-right 8px
    &y
      padding-top 4px
      padding-bottom 4px
    &y-1
      padding-top 8px
      padding-bottom 8px
    &y-2
      padding-top 16px
      padding-bottom 16px
    &t-1
      padding-top 8px
    &b
      padding-bottom 4px
  .m
    &x-auto
      margin-left auto
      margin-right auto
    &t-1
      margin-top 8px
    &t-2
      margin-top 16px
    &b
      margin-bottom 4px
    &b-1
      margin-bottom 8px
    &b-2
      margin-bottom 16px
  .b
    border 1px solid #000
    &-t
      border-top 1px solid #000
    &-r
      border-right 1px solid #000
    &-b
      border-bottom 1px solid #000
    &-l
      border-left 1px solid #000
  .block
    display block
  .flex
    display flex
    &-1
      flex 1 1 auto
    &-0
      flex 0 0 auto
    &-col
      flex-direction column
  .items-center
    align-items center
  .items-end
    align-items flex-end
  .justify-center
    justify-content center
  .justify-between
    justify-content space-between
  .vertical-text
    writing-mode vertical-rl
    text-orientation mixed
  .relative
    position relative
  small
    font-size 6.8pt
    line-height 10.35px
  p
    font-size 9pt
    line-height 13.8px
  b
    font-size 8.3pt
    font-weight 700
    line-height 12.65px
  strong
    font-weight 700
  h2
  h3
  h4
    margin-top 0
    margin-bottom 0
  h2
    font-size 45pt
    font-weight 900
  h3
    font-size 26.3pt
  h4
    font-size 12pt
    line-height 18.4px
.height-box
  height 142px
.tag-content
  flex 1 1 255px
  &--aside
    width 115px
    flex 0 0 115px
  .jadlog-logo
    width 63px
    height 47px
  .text-protocol
    font-size 7.5pt
    font-weight 700
    line-height 11.5px
    white-space nowrap
  .melhor-ponto-code
    width 82px
    height 82px
    margin-left auto
  .logo
    width auto
    padding 14px 24px
    img
      height 30px
  .shipment-id
  .service-name
    position absolute
    top calc(100% + 6px)
  .shipment-id
    left 8px
  .service-name
    left 50%
    transform translateX(-50%)
.section
  &-from
    p
      font-size 6pt
      line-height 9.2px
.inverse
  background-color #000
  color #fff
  -webkit-print-color-adjust exact
.bar-code
  width 47px
  overflow hidden
  height 250px
  position relative
  &-bottom
    width 85%
    height 53px
    display flex
    justify-content center
    overflow hidden
  .img-code
    height 38px
    position relative
    top 107px
    left -90px
    transform rotate(90deg) !important
    z-index 0
    rect
      height 60px
.track
  width 15px
  height 15px
  display flex
  align-items center
  justify-content center
  border 1px solid #000
.barcode-small
  height auto
  max-width 80%
</style>
